import { render } from "./InputPage.vue?vue&type=template&id=e1844542&scoped=true&ts=true"
import script from "./InputPage.vue?vue&type=script&lang=ts"
export * from "./InputPage.vue?vue&type=script&lang=ts"

import "./InputPage.vue?vue&type=style&index=0&id=e1844542&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1844542"]])

export default __exports__